function __match(v,ex){if(ex===null)return v===null;if(ex===undefined)return true;const t=typeof ex;if(t==='string'||t==='number'||t==='boolean')return typeof v===t;if(Array.isArray(ex)){if(!Array.isArray(v))return false;return ex.length?v.every(x=>__match(x,ex[0])):true}if(t==='object'){if(!v||typeof v!=='object'||Array.isArray(v))return false;return Object.keys(ex).every(k=>k in v&&__match(v[k],ex[k]))}return v===ex};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.__ex=ex;t.check=v=>__match(v,ex)}return t};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type};
/* tjs <- dom.ts */

import { cloneWithBindings } from './metadata'

import { ContentType, ValueElement } from './xin-types'

/* line 4 */
export function dispatch(target,type,{  bubbles = false,  composed = false } = { }) {
    const event = new Event(type, { bubbles, composed });
    target.dispatchEvent(event);
}
dispatch.__tjs = {
  "params": {
    "target": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    },
    "type": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "dom.ts:8"
}

/* line 18 */
function valueType(element) {
    if (element instanceof HTMLInputElement) {
        return element.type;
    }
    else if (element instanceof HTMLSelectElement &&
        element.hasAttribute('multiple')) {
        return 'multi-select';
    }
    else {
        return 'other';
    }
}
valueType.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "dom.ts:18"
}

/* line 43 */
function pad(n, len = 2) {
    return String(n).padStart(len, '0');
}
pad.__tjs = {
  "params": {
    "n": {
      "type": {
        "kind": "number"
      },
      "required": true,
      "default": null
    },
    "len": {
      "type": {
        "kind": "integer"
      },
      "required": false,
      "default": 2
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "dom.ts:43"
}

/* line 48 */
function dateToControlString(type,d) {
    switch (type) {
        case 'date':
            return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
        case 'month':
            return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}`;
        case 'datetime-local':
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
        default:
            return d.toISOString();
    }
}
dateToControlString.__tjs = {
  "params": {
    "type": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "d": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "dom.ts:48"
}

/* line 65 */
function msToTimeString(ms) {
    const seconds = Math.floor(ms / 1000);
    const hhmm = `${pad(Math.floor(seconds / 3600))}:${pad(Math.floor(seconds / 60) % 60)}`;
                                                
    return seconds % 60 === 0 ? hhmm : `${hhmm}:${pad(seconds % 60)}`;
}
msToTimeString.__tjs = {
  "params": {
    "ms": {
      "type": {
        "kind": "number"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "dom.ts:65"
}

/* line 74 */
function timeStringToMs(value) {
    const match = value.match(/^(\d\d):(\d\d)(?::(\d\d)(?:\.(\d+))?)?$/);
    if (match == null)
        return NaN;
    const [, h, m, sec, frac] = match;
    return ((Number(h) * 60 + Number(m)) * 60000 +
        Number(sec ?? 0) * 1000 +
        Number(frac ?? 0));
}
timeStringToMs.__tjs = {
  "params": {
    "value": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "number"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "dom.ts:74"
}

/* line 85 */
export function setValue(element, newValue) {
    const type = valueType(element);
    switch (type) {
        case 'radio':
                                                                            
            element.checked =
                newValue != null &&
                    element.value === String(newValue);
            break;
        case 'checkbox':
            element.checked = !!newValue;
            break;
        case 'date':
        case 'datetime-local':
        case 'month':
        case 'week': {
            const input = element;
            if (newValue == null || newValue === '') {
                                                                             
                input.value = '';
            }
            else if (newValue instanceof Date || typeof newValue === 'number') {
                const d = newValue instanceof Date ? newValue : new Date(newValue);
                if (type === 'week') {

                    try {
                        input.valueAsDate = d;
                    }
                    catch (_e) {
                                                                         
                    }
                }
                else {
                    input.value = dateToControlString(type, d);
                }
            }
            else {
                input.value = String(newValue);
            }
            break;
        }
        case 'time': {
            const input = element;
            if (newValue == null || newValue === '') {
                input.value = '';
            }
            else if (typeof newValue === 'number') {
                input.value = msToTimeString(newValue);
            }
            else if (newValue instanceof Date) {
                input.value = `${pad(newValue.getHours())}:${pad(newValue.getMinutes())}:${pad(newValue.getSeconds())}`;
            }
            else {
                input.value = String(newValue);
            }
            break;
        }
        case 'multi-select':
            for (const option of Array.from(element.querySelectorAll('option'))) {

                option.selected = Array.isArray(newValue)
                    ? newValue.map(String).includes(option.value)
                    : newValue != null
                        ? !!newValue[option.value]
                        : false;
            }
            break;
        default:

            element.value = newValue == null ? '' : newValue;
    }
}
setValue.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    },
    "newValue": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "dom.ts:66"
}

const PickMap = Type('PickMap')

/* line 162 */
/* TODO: TS types degraded — element: ValueElement */
export function getValue(element) {
    const type = valueType(element);
    switch (type) {
        case 'radio': {
            const radio = element.parentElement?.querySelector(`[name="${element.name}"]:checked`);
            return radio != null ? radio.value : null;
        }
        case 'checkbox':
            return element.checked;
        case 'number':
        case 'range': {
            const input = element;
            const n = typeof input.valueAsNumber === 'number'
                ? input.valueAsNumber
                : Number(input.value);
            return Number.isNaN(n) ? input.value : n;
        }
        case 'date':
        case 'datetime-local':
        case 'month':
        case 'week': {
            const input = element;
            const d = input.valueAsDate ??
                (input.value !== '' ? new Date(input.value) : null);
            return d != null && !Number.isNaN(d.getTime()) ? d : input.value;
        }
        case 'time': {
            const input = element;
            let n = typeof input.valueAsNumber === 'number' ? input.valueAsNumber : NaN;
            if (Number.isNaN(n))
                n = timeStringToMs(input.value);
            return Number.isNaN(n) ? input.value : n;
        }
        case 'multi-select':
            return Array.from(element.querySelectorAll('option')).reduce((map, option) => {
                map[option.value] = option.selected;
                return map;
            }, {});
        default:
            return element.value;
    }
}
getValue.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "any"
      },
      "required": true
    }
  },
  "unsafe": true,
  "source": "dom.ts:143"
}

const { ResizeObserver } = globalThis;

export const resizeObserver = ResizeObserver != null
    ? new ResizeObserver((entries) => {
        for (const entry of entries) {
            const element = entry.target;
            dispatch(element, 'resize');
        }
    })
    : {
        observe() { },
        unobserve() { },
    };

/* line 227 */
/* TODO: TS types degraded — content: ContentType | null | undefined */
export function appendContentToElement(elt, content, cloneElements = true) {
    if (elt != null && content != null) {
        if (typeof content === 'string') {
            elt.textContent = content;
        }
        else if (Array.isArray(content)) {
            content.forEach((node) => {
                elt.append(node instanceof Node && cloneElements ? cloneWithBindings(node) : node);
            });
        }
        else if (content instanceof Node) {
            elt.append(cloneElements ? cloneWithBindings(content) : content);
        }
        else {
            throw new Error('expect text content or document node');
        }
    }
}
appendContentToElement.__tjs = {
  "params": {
    "elt": {
      "type": {
        "kind": "union",
        "members": [
          {
            "kind": "object",
            "nullable": true,
            "shape": {}
          },
          {
            "kind": "undefined"
          }
        ]
      },
      "required": true,
      "default": null
    },
    "content": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "cloneElements": {
      "type": {
        "kind": "boolean"
      },
      "required": false,
      "default": true
    }
  },
  "unsafe": true,
  "source": "dom.ts:202"
}